<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      short-title="TOKTOK"
      title="TOKTOK"
    >
      <template slot="links">
        <!-- <sidebar-item
          :link="{
            name: $t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: '/dashboard'
          }"
        >
        </sidebar-item> -->
        <sidebar-item v-for="reportMenu in reports" v-bind:key="reportMenu.groupName"
          :link="{ name: reportMenu.groupName, icon: reportMenu.icon ? reportMenu.icon : 'tim-icons icon-paper' }"
        >
          <sidebar-item v-for="item in reportMenu.Reports" v-bind:key="item.reportname"
            :link="{ name: item.title, path: '/report/' + item.reportname, params: [{test1: 'testing1'}]}"
          ></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './ReportNavbar.vue';
import ContentFooter from './ReportFooter.vue';
import DashboardContent from './Content.vue';
import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';
import { SlideYDownTransition, ZoomCenterTransition } from 'vue2-transitions';
import { getToken, getGroups } from '@/utils/auth.js'

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    DashboardContent,
    SlideYDownTransition,
    ZoomCenterTransition
  },
  data() {
    return {
      sidebarBackground: 'orange', //vue|blue|orange|green|red|primary
      reports: null,
      token: '',
      role: []
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('main-panel');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    },
    // Тайлангийн жагсаалт авах
    fetchReports() {
      getGroups().then(data => {
        this.role = data;
        if (data.length > 0){
          const baseURI = process.env.VUE_APP_reportGroupURI;
          this.$http.get(baseURI,{
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.token,
              'role': data
            }
          }).then((result) => {
            let tempArr = [];
            result.data.forEach(el => {
                tempArr.push(el)
            })
            this.reports = tempArr
            // this.reports = result.data;
          });
        }
      })
    }
  },
  mounted() {
    getToken().then((data) => {
      this.token = data
      this.fetchReports()
    })
    this.initScrollbar()
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
